import { FloatingList } from "@floating-ui/react";
import { ItemContext, Props } from "./ListNavigation.Parts";

export const ListNavigation = ({
  children,
  elementsRef,
  labelsRef,
  activeIndex,
  getItemProps,
}: Props) => (
  <ItemContext.Provider value={{ activeIndex, getItemProps }}>
    <FloatingList elementsRef={elementsRef} labelsRef={labelsRef}>
      {children}
    </FloatingList>
  </ItemContext.Provider>
);
